import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import HeaderPortal from '../../../../components/layout/HeaderPortal';
import ItemsListBrowser from './ItemsListBrowser';
import Portal from 'utils/portal/Portal';
import { IconButton } from '@totalsoft/rocket-ui';
import { areas } from 'constants/areas';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { useTranslation } from 'react-i18next';
import { withAreaGetter } from 'providers/AreasConsumers';
import { ADMIN_ITEMS_READ, ADMIN_ITEMS_WRITE } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_ITEMS_WRITE} withForbiddenPage={false}>
          <IconButton
            onClick={() => historyContext.push(`/items/new`)}
            type='add'
            fontSize='medium'
            color='transparent'
            tooltip={t('Tooltips.Items.Add')}
          />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_ITEMS_READ}>
        <ItemsListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
